import { render, staticRenderFns } from "./HostingList.vue?vue&type=template&id=5d96a131&scoped=true"
import script from "./HostingList.vue?vue&type=script&lang=js"
export * from "./HostingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d96a131",
  null
  
)

export default component.exports